import { Box, makeStyles, Typography } from '@material-ui/core';
import CardItem, { ECardItemType } from 'components/CardItem/CardItem';
import { IProductItem, IRestaurant } from 'features/home/types/homeTypes';
import { mapProductToCartItemData } from 'features/home/utils/dataMapping';
import useDrag from 'features/step-menu/components/ProductItemSliderStep/useDrag';
import React from 'react';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import { useTranslation } from 'react-i18next';
import { theme } from 'theme';
import { filterVisibility } from 'submodules/OrderCore';
import './index.css';

const useStyle = makeStyles({
  slider: {
    padding: '1rem 0',
    minWidth: '62.2rem',
  },
  recomandation: { marginTop: 0, color: theme.palette.grey[800], marginBottom: 10 },
  dot: {
    backgroundColor: theme.palette.grey[800],
    width: 10,
    height: 10,
    borderRadius: '50%',
    margin: 10,
  },
  overFlow: {
    // overflow: 'hidden',
    margin: '10px 0',

    '& .slick-list': {
      paddingBottom: '1rem',
    },

    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% )',
    },
    [theme.breakpoints.up('sm')]: {
      width: '100%',
    },
  },
});

export type scrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;

interface ProductItemsSliderProps {
  productItems: IProductItem[];
  showTitle: boolean;
  restaurant: IRestaurant;
  inactiveMenu: any;
  title?: string;
  dot?: boolean;
}

const ProductItemsSlider = ({
  productItems,
  showTitle,
  restaurant,
  inactiveMenu,
  title = 'Recommendation',
  dot = true,
}: ProductItemsSliderProps) => {
  const classes = useStyle();

  const { dragStart, dragStop, dragMove } = useDrag();

  const handleDrag = ({ scrollContainer }: scrollVisibilityApiType) => {
    return (ev: React.MouseEvent) =>
      dragMove(ev, (posDiff) => {
        if (scrollContainer.current) {
          scrollContainer.current.scrollLeft += posDiff;
        }
      });
  };

  const { t } = useTranslation();

  return (
    <Box className={classes.overFlow}>
      {showTitle && productItems.length > 0 && (
        <Typography variant="h3" className={classes.recomandation}>
          {t(title)}
        </Typography>
      )}
      <ScrollMenu
        onWheel={onWheel}
        onMouseDown={() => dragStart}
        onMouseUp={() => dragStop}
        onMouseMove={handleDrag}
      >
        {productItems
          .filter((item) => item.active && filterVisibility(item))
          .map((item) => (
            <CardItem
              isSoldOut={inactiveMenu?.includes(item.id)}
              key={item.id}
              data={mapProductToCartItemData(
                item,
                restaurant.isBigMenuImageUsed,
                restaurant.currencySymbol,
              )}
              type={ECardItemType.VERTICAL}
            />
          ))}
      </ScrollMenu>
      {dot && (
        <ScrollMenu
          onWheel={onWheel}
          onMouseDown={() => dragStart}
          onMouseUp={() => dragStop}
          onMouseMove={handleDrag}
        >
          {productItems.slice(0, 10).map((item, index) => {
            return <div key={index.toString()} className={classes.dot}></div>;
          })}
        </ScrollMenu>
      )}
    </Box>
  );
};

export function onWheel(apiObj: scrollVisibilityApiType, ev: React.WheelEvent): void {
  const isTouchPad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

  if (isTouchPad) {
    ev.stopPropagation();
    return;
  }

  if (ev.deltaY < 0) {
    apiObj.scrollNext();
  } else if (ev.deltaY > 0) {
    apiObj.scrollPrev();
  }
}

export default ProductItemsSlider;
